import { combineReducers } from 'redux';
import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { AuthenticationReducer } from './authentication/auth.reducer';
import { UserActionTypes } from './user/user.model';
import { UserReducer } from './user/user.reducers';
import { TransactionReducer } from './transaction/transaction.reducers';
import { WhitelistReducer } from './whitelist/whitelist.reducer';
import { WithdrawReducer } from './withdraw/withdraw.reducer';
import { OrderReducer } from './order/order.reducers';

const appReducer = combineReducers({
    UserReducer,
    AuthenticationReducer,
    TransactionReducer,
    WhitelistReducer,
    WithdrawReducer,
    OrderReducer
});

const persistConfig = {
    key: "mlm",
    storage: storageSession,
};
const rootReducer = (state, action) => {
    if (action.type === UserActionTypes.USER_LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
